<template>
  <v-card v-if="!limitedUser" class="custom-card" v-resize="utility_onResize">
    <v-flex xs12 v-if="!limitedUser">
      <v-layout wrap class="text-center">
        <v-flex xs12 sm6 md3 v-if="isMobile">
          <v-btn :to="`/settings/profile`" text>{{ $t('settingsNav.editProfile') }}</v-btn>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-btn :to="`/settings/account`" text>{{ $t('settingsNav.account') }}</v-btn>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-btn :to="`/settings/licenses`" text>{{ $t('settingsNav.licenses') }}</v-btn>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-btn :to="`/settings/history`" text>{{ $t('settingsNav.orderhistory') }}</v-btn>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-btn :to="`/settings/preferences`" text>{{ $t('settingsNav.preferences') }}</v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-card>
</template>

<script>
import utilityMixin from '@/mixins/utilityMixin';

export default {
  name: 'SettingsBottomNav',
  mixins: [utilityMixin],
  props: {
    limitedUser: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.custom-card {
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 10px;
  border-radius: var(--border-10);
}
</style>
